/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Preparing_VideoInputs */

const en_audio_description_export_status_preparing_video = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing video export...`)
};

const fr_audio_description_export_status_preparing_video = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation de l'exportation vidéo...`)
};

const de_audio_description_export_status_preparing_video = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoexport wird vorbereitet...`)
};

const it_audio_description_export_status_preparing_video = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione dell'esportazione video...`)
};

const ru_audio_description_export_status_preparing_video = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подготовка к экспорту видео...`)
};

const es_audio_description_export_status_preparing_video = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando exportación de vídeo...`)
};

const zh_cn2_audio_description_export_status_preparing_video = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在准备视频导出……`)
};

const ja_audio_description_export_status_preparing_video = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオのエクスポートを準備しています...`)
};

const hi_audio_description_export_status_preparing_video = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात की तैयारी हो रही है...`)
};

const pt_pt2_audio_description_export_status_preparing_video = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando a exportação de vídeo...`)
};

/**
* | output |
* | --- |
* | "Preparing video export..." |
*
* @param {Audio_Description_Export_Status_Preparing_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_preparing_video = /** @type {((inputs?: Audio_Description_Export_Status_Preparing_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Preparing_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_preparing_video(inputs)
	if (locale === "de") return de_audio_description_export_status_preparing_video(inputs)
	if (locale === "it") return it_audio_description_export_status_preparing_video(inputs)
	if (locale === "ru") return ru_audio_description_export_status_preparing_video(inputs)
	if (locale === "es") return es_audio_description_export_status_preparing_video(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_preparing_video(inputs)
	if (locale === "ja") return ja_audio_description_export_status_preparing_video(inputs)
	if (locale === "hi") return hi_audio_description_export_status_preparing_video(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_preparing_video(inputs)
	return en_audio_description_export_status_preparing_video(inputs)
});